import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import CustomViewPage from '../../../components/CustomComponents/CustomViewPage'
import { useContentQuestion } from '../../../hooks/Others/LearningAndDevelopment/useContentQuestion'
import { formatDate } from '../../../shared/constants'
import QuestionAnswerDialog from '../../../components/Dialog/QuestionAnswerDialog'
export default function ViewQuiz() {
  const { getContentQuestion, contentQuestion, loading } = useContentQuestion()
  const params = useParams()
  const [questions, setQuestions] = useState(false)

  const [data, setData] = useState([])

  useEffect(() => {
    getContentQuestion({ _id: params.contentQuestionId })
  }, [params.contentQuestionId])

  useEffect(() => {
    if (contentQuestion) {
      setData([
        { label: 'Category Content Code', data: contentQuestion.contentQuestionCode },
        { label: 'Name', data: `${contentQuestion.name}` },
        { label: 'Expiry Date', data: formatDate(contentQuestion.expiryDate) },
        { label: 'Training Category', data: contentQuestion.trainingCategory && contentQuestion.trainingCategory.name },
        { label: 'Category Content', data: contentQuestion.trainingCategoryContent && contentQuestion.trainingCategoryContent.name },
        { label: 'Total Questions', data: contentQuestion.totalQuestions },
        { label: 'Status', data: contentQuestion.status },
        { label: 'Questions', data: 'View Questions', style: { cursor: 'pointer', color: 'blue', textDecoration: 'underline' }, onClick: () => setQuestions(contentQuestion.questions) },
      ])
    }
  }, [contentQuestion])
  return (
    <>
      <QuestionAnswerDialog questions={questions} open={questions.length > 0} handleClose={() => setQuestions(false)} />

      <CustomViewPage loading={loading} heading="Assessment" editUrl="content-question" id={params.contentQuestionId} redirect="ALL_CONTENTQUESTION" data={data} />
    </>
  )
}
